import {ReactElement} from "react";
import {WebsocketEvent} from "@devour/client";
import useWebsocket from "@/hooks/useWebsocket";
import useOnLogout from "@/hooks/useOnLogout";
import {useQueryClient} from "@tanstack/react-query";

function GlobalWebsocketManager(): ReactElement {
    const {devourLogout} = useOnLogout();
    const queryClient = useQueryClient();

    useWebsocket<void>(WebsocketEvent.REFRESH, () => window.location.reload());
    useWebsocket<void>(WebsocketEvent.LOGOUT, async () => {
        try {
            await devourLogout();
        } catch (error) {
            console.error("Websocket logout failed:", error);
        }
    }, true);

    // Listen for QUEST_REFRESH to update quest data across all devices
    useWebsocket<void>(WebsocketEvent.QUEST_REFRESH, () => {
        // Invalidate all quest-related queries
        const queries = [
            "devourplay-user-quest-stats",
            "devourplay-quests",
            "devourplay-guild-quests",
            "devourplay-challenges",
            "devourplay-user-challenges",
            "getUserProfileQuests",
        ];

        queries.forEach(queryKey => {
            void queryClient.invalidateQueries([queryKey]);
        });
    }, true);

    return null;
}

export default GlobalWebsocketManager;
